var ImageAspectRatio = /* @__PURE__ */ ((ImageAspectRatio2) => {
  ImageAspectRatio2["ar1x1"] = "1x1";
  ImageAspectRatio2["ar4x3"] = "4x3";
  ImageAspectRatio2["ar3x4"] = "3x4";
  return ImageAspectRatio2;
})(ImageAspectRatio || {});
var GameImageSizeName = /* @__PURE__ */ ((GameImageSizeName2) => {
  GameImageSizeName2["large"] = "large";
  GameImageSizeName2["normal"] = "normal";
  GameImageSizeName2["small"] = "small";
  GameImageSizeName2["icon"] = "icon";
  return GameImageSizeName2;
})(GameImageSizeName || {});
const ACCEPTABLE_PER_PAGE = [10, 20, 50];
export {
  ACCEPTABLE_PER_PAGE,
  GameImageSizeName,
  ImageAspectRatio
};
